// @flow
import warning from 'assets/warning.png'
import * as React from 'react'
import Button from 'ui/atoms/Button'
import Heading from 'ui/atoms/Heading'
import Space from 'ui/atoms/Space'
import Text from 'ui/atoms/Text'
import Page from 'ui/organisms/Page'

type Props = {
  buttonText?: string,
  heading: string,
  onClick?: () => void,
  text: string,
}

function ErrorPage({
  buttonText = 'Continue',
  heading,
  onClick,
  text,
}: Props): React.Node {
  return (
    <Page centerContainer>
      <Space center>
        <img alt="warning" className="inline-block" src={warning} />
        <Heading>{heading}</Heading>
        <Text>{text}</Text>
        {onClick && (
          <Button $primary onClick={onClick}>
            {buttonText}
          </Button>
        )}
      </Space>
    </Page>
  )
}

export default ErrorPage
